import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import EmpresaForm from '../components/EmpresaForm';
import { maskCPF, maskCNPJ } from '../utils/Masker';
import moment from "moment-timezone"; // VALIDAR DATAS
import { getUsuario } from "../utils/LoginManager";
import { resolveImageUrl } from '../utils/Storage';

const { Column } = Table;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/empresas', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          nome: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    let request;
    if (registro.emp_codigo) {
      request = axios.put(`/empresas/update/${registro.emp_codigo}`, registro);
    } else {
      request = axios.post(`/empresas/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Empresa gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/empresas/show/${registro.emp_codigo}`)
      .then(response => {
        const { data } = response;

        data.emp_municipio = {
          key: String(data.emp_municipio),
          label: data.cmun_descricao,
          cmun_uf: String(data.cmun_uf),
          cuf_sigla: data.cuf_sigla,
        }

        const documento = String(data.emp_cpf_cnpj).replace(/[^A-Z0-9]/g, '');
        data.emp_cpf_cnpj = documento.length === 11 ? maskCPF(data.emp_cpf_cnpj) : maskCNPJ(data.emp_cpf_cnpj);
        data.emp_data_contrato = moment(data.emp_data_contrato, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.pathImagem = data.emp_logo ? resolveImageUrl(`imagens/${data.emp_logo}`) : '';
        // data.pathImagem = data.emp_logo ? resolveImageUrl(`imagens/emp${data.emp_codigo}.${data.emp_logo}`) : '';

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        emp_data_contrato: moment().format('DD/MM/YYYY'), //moment(data.emp_data_contrato, 'YYYY-MM-DD').format('DD/MM/YYYY')
        // emp_data_contrato: moment(new Date(), 'YYYY-MM-DD').format('DD/MM/YYYY'),
        emp_municipio: {
          key: String(this.state.usuario.emp_municipio),
          label: this.state.usuario.cmun_descricao,
          cmun_uf: String(this.state.usuario.cmun_uf),
          cuf_sigla: this.state.usuario.cuf_sigla,
        },
        imgNome: '',
        imgSize: '0',
        imgData: '',
        base64: '',
        pathImagem: "",
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/empresas/ativa/${registro.emp_codigo}/1`)
    } else {
      request = axios.put(`/empresas/ativa/${registro.emp_codigo}/0`)
    }

    request.then(response => {
      registro.emp_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };



  renderPFJ = (emp_cpf_cnpj) => {
    if ((String(emp_cpf_cnpj).length) === 11) {
      return (
        <span>
          {maskCPF(emp_cpf_cnpj)}
        </span>
      );
    } else {
      return (
        <span>
          {maskCNPJ(emp_cpf_cnpj)}
        </span>
      );
    }
  };

  renderAtiva = (emp_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={emp_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
      />
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Editar">
        <Button type="primary" size="small" onClick={() => this.onEditarClick(registro)} icon="edit" />
      </Tooltip>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Empresas</span>
        <div className="divider-page1" />

        <div className="pageFiltro">
          {/* <Button
            type="primary"
            onClick={this.onAdicionarClick}
            className="botao-primary"
          >
            Adicionar
          </Button> */}

          <Search
            placeholder="Buscar por Nome"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <EmpresaForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          scroll={{ x: 600 }}
          rowKey={(registro => registro.emp_codigo)}
        >
          <Column
            key="emp_codigo"
            dataIndex="emp_codigo"
            title={this.renderTitulo("Código")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="emp_cpf_cnpj"
            dataIndex="emp_cpf_cnpj"
            title={this.renderTitulo("CPF/CNPJ")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderPFJ}
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="emp_nome"
            dataIndex="emp_nome"
            title={this.renderTitulo("Nome")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={120}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="emp_razao_social"
            dataIndex="emp_razao_social"
            title={this.renderTitulo("Razão Social")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={120}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cmun_descricao"
            dataIndex="cmun_descricao"
            title={this.renderTitulo("Município")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cuf_sigla"
            dataIndex="cuf_sigla"
            title={this.renderTitulo("UF")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={40}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="emp_situacao"
            dataIndex="emp_situacao"
            title={this.renderTitulo("Situação")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderAtiva}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
            render={this.renderAcoes}
            width={70}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EmpresasPage.js